import { TimeInvariantBase } from '../TimeInvariantBase';
import { NumberAttribute, getAttributesToSerialize } from '../attributes';

/**
 * Contains watermark margins & max size for one aspect ratio
 */
export class WatermarkLayout extends TimeInvariantBase {
    override _classType = 'WatermarkLayout';
    override name = 'WatermarkLayout';

    @NumberAttribute()
    accessor marginLeft = 0;
    @NumberAttribute()
    accessor marginTop = 0;
    @NumberAttribute()
    accessor marginRight = 0;
    @NumberAttribute()
    accessor marginBottom = 0;
    @NumberAttribute()
    accessor maxWidth = 0;
    @NumberAttribute()
    accessor maxHeight = 0;

    override get propertiesToSerialize(): Array<string> {
        return getAttributesToSerialize(this);
    }
}
